import App from "./layout/App";
import Header from "./layout/Header";
import LoginAndRegistrationHeader from "./layout/LoginAndRegistrationHeader";
import LoginAndRegistrationScreen from "./layout/LoginAndRegistrationScreen";
import SlotMobileGame from "./layout/SlotMobileGame";
import WorldCup from "./layout/WorldCup";
import Teams from "./layout/Teams";
import HeaderMobile from "./layout/HeaderMobile";
import Footer from "./layout/Footer";
import FooterMobile from "./layout/FooterMobile";
import Banner from "./layout/Banner";
import BannerMobile from "./layout/BannerMobile";
import Screen from "./layout/Screen";
import ScreenTitle from "./common/ScreenTitle";
import SportTypes from "./common/SportTypes";
import Events from "./common/betEvents/Events";
import EventsLive from "./common/betEvents/EventsLive";
import EventsSports from "./common/betEvents/EventsSports";
import EventsVirtual from "./common/betEvents/EventsVirtual";
import EventsKiron from "./common/spinAndWin/GameBoard";
import VirtualMenu from "./common/virtual/VirtualMenu";
import VirtualVideo from "./common/virtual/VirtualVideo";
import MenuTree from "./common//MenuTree";
import Bets from "./common/betEvents/";
import BetSlip from "./common/betSlip/BetSlip";
import Images from "./common/Images";
import Alert from "./common/Alert";
import SportIcon from "./common/SportIcon";
import Loading from "./common/Loading";
import Beforeunload from "./common/Beforeunload";
import * as Swipable from "./common/Swipable";
import Search from "./common/Search";
import PhoneNumber from "./common/PhoneNumber";
import Modal from "./common/Modal";
import SlotList from "./common/slot/SlotList";
import SlotsGame from "./common/slot/SlotsGame";
import OddField from "./common/spinAndWin/OddFields";
import InfiniteScrollComponent from "./common/InfiniteScrollComponent";
import SpecialOddFieldButton from "./common/spinAndWin/SpecialOddFieldButton";
import { handleWindowResize } from "./WindowChange";
import ViewportBlock from "../components/common/ViewPortController";
import { useOnScreen, OnScreenWrapper } from "../components/common/UseOnScreen";
import SlotsCourasel from "./common/newSlots/SlotsCourasel";
import SlotsCategories from "./common/newSlots/SlotsCategories";

export {
  App,
  Header,
  HeaderMobile,
  Footer,
  FooterMobile,
  Banner,
  BannerMobile,
  Screen,
  ScreenTitle,
  SportTypes,
  Events,
  EventsLive,
  EventsSports,
  EventsVirtual,
  EventsKiron,
  MenuTree,
  VirtualMenu,
  VirtualVideo,
  Bets,
  BetSlip,
  Images,
  Alert,
  SportIcon,
  Loading,
  Beforeunload,
  Swipable,
  Search,
  PhoneNumber,
  Modal,
  SlotList,
  SlotsGame,
  LoginAndRegistrationScreen,
  LoginAndRegistrationHeader,
  SlotMobileGame,
  WorldCup,
  Teams,
  OddField,
  SpecialOddFieldButton,
  handleWindowResize,
  InfiniteScrollComponent,
  ViewportBlock,
  useOnScreen,
  OnScreenWrapper,
  SlotsCourasel,
  SlotsCategories
};
